export enum Integration {
  Plaid = 'plaid',
  QuickBooks = 'qb',
  Xero = 'xero',
}
